import React from 'react';

const SUPPORTED_CHARS = new Set([
  ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  ...'abcdefghijklmnopqrstuvwxyz',
  ...'012345678',
  ...'ĄąĆćĘęŁłŃńÓóŚśŹźŻż',
  ...'!"\',*+-./?:;_`(){}[]',
]);

const GLYPH_OVERRIDES = {
  C: '/litery/u0063.svg',
};

const glyphSrc = (char) => {
  if (GLYPH_OVERRIDES[char]) return GLYPH_OVERRIDES[char];
  const code = char.codePointAt(0).toString(16).toUpperCase().padStart(4, '0');
  return `/litery/u${code}.svg`;
};

const CaliLetters = ({ text = '', as: Tag = 'span', className = '', wordClassName = '', ...props }) => {
  const value = String(text);
  const chunks = value.split(/(\s+)/);

  return (
    <Tag className={`cali-letters ${className}`.trim()} aria-label={value} {...props}>
      {chunks.map((chunk, chunkIndex) => {
        if (!chunk) return null;
        if (/^\s+$/.test(chunk)) {
          return <span key={`space-${chunkIndex}`} aria-hidden="true" className="cali-letter-space" />;
        }

        return (
          <span key={`word-${chunkIndex}`} aria-hidden="true" className={`cali-letter-word ${wordClassName}`.trim()}>
            {[...chunk].map((char, charIndex) => (
              SUPPORTED_CHARS.has(char) ? (
                <img
                  key={`${char}-${charIndex}`}
                  src={glyphSrc(char)}
                  alt=""
                  data-char={char}
                  className="cali-letter-glyph"
                  draggable="false"
                />
              ) : (
                <span key={`${char}-${charIndex}`} className="cali-letter-fallback">
                  {char}
                </span>
              )
            ))}
          </span>
        );
      })}
    </Tag>
  );
};

export default CaliLetters;
